import { useApp } from "../context/useApp"
import { Icon } from "../parts/Icon"
import { _, getSortedTickets, parseProductPrice } from "../utils/helpers"
import { booking, PRODUCTS_WICH_QTY_IS_FIXED_TO_PAX, SCREEN_BREAKPOINT_1, DEFAULT_DIALOG_HANDLE, SURCHARGE_NAME, metrics } from "../utils/symbols"
import { Product, SafeZone } from "../types"
import { ZoneCardWithProducts } from "../parts/ZoneCardWithProdcts"
import { useState } from "react"
import { Switch } from "../parts/inputs/Switch"

export const TicketSelectionWithoutTables = () => {

    const {
        state: { products, screen, dialogHandles },
        actions: { setMapVisible }
    } = useApp()

    const [open, setOpen] = useState(0)
    const sortedTickets = getSortedTickets(products)
    const dialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const handleProductQtyChange = (product: Product, newQty: number) => {
        const isFixedToPax = PRODUCTS_WICH_QTY_IS_FIXED_TO_PAX.includes(product.id)
        const qty = isFixedToPax ? newQty * booking.pax : newQty
        booking.handleProductWithOutTables(product, qty).render()
        if (product.type === "ticket") {
            
            metrics.ticketsSelectionEvent(booking.getBookingDataByReference())
        }
    }
    const openDialog = (product: Product) => {
        dialogHandle.openDialog({
            className: 'product w-100 h-100 df aic jcc',
            dialog: 'product', 
            product
        })
    }
    /**
         * TEST AB NEEDS ==================================
         */
        const cancellationFee = products.find(product => product.category === "insurance" && product.name !== SURCHARGE_NAME)
        /**
         * TEST AB NEEDS ==================================
         */

    return ["tickets", "products"].includes(booking.step) ? (
        <>
        <div className="w-100 mb-8 mr-10 ticket-selection-test-ab">
            {screen.width >= SCREEN_BREAKPOINT_1 && (
                <button 
                    type="button"
                    className="button b-0 p-0 df aic mb-7" 
                    onClick={() => {
                        booking.setBookingStep("shift").render()
                    }}
                >
                    <Icon icon={'arrow'} className="rt180 mr-5"/>
                    <p className="text s18-600">{_('0ge_gobac__')}</p>
                </button>
            )}
            <h1 className="text s24-600">{_("0ab_selec__")}</h1>
            <div className="w-100 my-10 test-ab-zones-container">
                {
                    sortedTickets.map(ticket => {
                        if (ticket.category === "children") return null
                        return (
                            <ZoneCardWithProducts 
                                key={ticket.id}
                                zone={ticket.zone as SafeZone}
                                open={open === ticket.id}
                                onZoneClick={() => setOpen(prev => prev === ticket.id ? 0 : ticket.id)}
                                onProductChange={handleProductQtyChange}
                            />
                        )
                    })
                }
                   {screen.width < SCREEN_BREAKPOINT_1 && open !== 0 && (
                <button 
                    className="test-ab-map-button"
                    onClick={() => setMapVisible(true)}
                >
                    <span>{_("0ab_seesi__")}</span>
                    <Icon icon="map"/>
                </button>
            )}
            </div>
        </div>
            {screen.width < SCREEN_BREAKPOINT_1 && open === 0 && (
                <button 
                    className="test-ab-map-button"
                    onClick={() => setMapVisible(true)}
                >
                    <span>{_("0ab_seesi__")}</span>
                    <Icon icon="map"/>
                </button>
            )}
            {cancellationFee && screen.width < SCREEN_BREAKPOINT_1 && booking.step !== "personal-details" &&(
                <div className={`white-box mt-10 ${booking.pax === 0 ? "disabled" : ""}`}>
                    <button 
                        className="df aic"
                        onClick={() => openDialog(cancellationFee)}
                    >
                        <span className="text s18-500">{_("0ab_cance__")}</span>
                        <Icon icon="info" />
                    </button>
                    <div className="df aic jcfe">
                        <p className="text s18-600 right mr-5">
                            {parseProductPrice(cancellationFee)}
                        </p>
                        <Switch
                            disabled={booking.pax === 0}
                            value={booking.getProductQty(cancellationFee.id)}
                            onChange={(checked) => handleProductQtyChange(cancellationFee, checked ? 1 : 0)}
                        />
                    </div>
                </div>
            )}
        </>
    ) : null
}